import React from "react";
import { Link } from "react-router-dom";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/outline";

function TermsOfService() {
  const sections = [
    {
      title: "1. Agreement to Terms",
      content: (
        <p className="text-gray-200 leading-relaxed">
          By accessing and using the ingersollbuilt.ca website and services, you
          accept and agree to be bound by and comply with the terms and
          provision of this agreement. If you do not agree to abide by the
          above, please do not use this service.
        </p>
      ),
    },
    {
      title: "2. Use License",
      content: (
        <>
          <p className="text-gray-200 mb-3 leading-relaxed">
            Permission is granted to temporarily download one copy of the
            materials (information or software) on Ingersoll Built's website for
            personal, non-commercial transitory viewing only. This is the grant
            of a license, not a transfer of title, and under this license you
            may not:
          </p>
          <ul className="list-disc ml-6 text-gray-200 space-y-2">
            <li>Modify or copy the materials</li>
            <li>
              Use the materials for any commercial purpose, or for any public
              display
            </li>
            <li>
              Attempt to decompile or reverse engineer any software contained on
              the website
            </li>
            <li>
              Remove any copyright or other proprietary notations from the
              materials
            </li>
            <li>
              Transfer the materials to another person or "mirror" the materials
              on any other server
            </li>
            <li>
              Attempt to gain unauthorized access to any portion or feature of
              the website
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "3. Disclaimer",
      content: (
        <p className="text-gray-200 leading-relaxed">
          The materials on Ingersoll Built's website are provided on an 'as is'
          basis. Ingersoll Built makes no warranties, expressed or implied, and
          hereby disclaims and negates all other warranties including, without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non-infringement of intellectual
          property or other violation of rights.
        </p>
      ),
    },
    {
      title: "4. Limitations",
      content: (
        <p className="text-gray-200 leading-relaxed">
          In no event shall Ingersoll Built or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption) arising out of the use or
          inability to use the materials on Ingersoll Built's website, even if
          Ingersoll Built or an authorized representative has been notified
          orally or in writing of the possibility of such damage.
        </p>
      ),
    },
    {
      title: "5. Accuracy of Materials",
      content: (
        <p className="text-gray-200 leading-relaxed">
          The materials appearing on Ingersoll Built's website could include
          technical, typographical, or photographic errors. Ingersoll Built does
          not warrant that any of the materials on its website are accurate,
          complete, or current. Ingersoll Built may make changes to the
          materials contained on its website at any time without notice.
        </p>
      ),
    },
    {
      title: "6. Links",
      content: (
        <p className="text-gray-200 leading-relaxed">
          Ingersoll Built has not reviewed all of the sites linked to its
          website and is not responsible for the contents of any such linked
          site. The inclusion of any link does not imply endorsement by
          Ingersoll Built of the site. Use of any such linked website is at the
          user's own risk.
        </p>
      ),
    },
    {
      title: "7. Modifications",
      content: (
        <p className="text-gray-200 leading-relaxed">
          Ingersoll Built may revise these terms of service for its website at
          any time without notice. By using this website, you are agreeing to be
          bound by the then current version of these terms of service.
        </p>
      ),
    },
    {
      title: "8. Governing Law",
      content: (
        <p className="text-gray-200 leading-relaxed">
          These terms and conditions are governed by and construed in accordance
          with the laws of Canada, and you irrevocably submit to the exclusive
          jurisdiction of the courts in that location.
        </p>
      ),
    },
    {
      title: "Contact Us",
      content: (
        <>
          <p className="text-gray-200 mb-4 leading-relaxed">
            If you have any questions about these Terms of Service, please
            contact us:
          </p>
          <div className="bg-gray-700 bg-opacity-50 p-4 rounded space-y-2 border border-white border-opacity-10">
            <p className="text-gray-200 flex items-center gap-2">
              <PhoneIcon className="w-4 h-4 text-cyan-400 flex-shrink-0" />
              (555) 123-4567
            </p>
            <p className="text-gray-200 flex items-center gap-2">
              <EnvelopeIcon className="w-4 h-4 text-cyan-400 flex-shrink-0" />
              info@ingersollbuilt.ca
            </p>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="mb-8 animate-fade-in">
          <Link
            to="/"
            className="text-cyan-400 hover:text-white transition mb-4 inline-block"
          >
            ← Back to Home
          </Link>
          <h1 className="text-5xl font-bold mb-2">Terms of Service</h1>
          <p className="text-gray-300">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Content */}
        <div className="space-y-5 animate-slide-in-right">
          {sections.map((section, index) => (
            <section
              key={section.title}
              className="bg-white bg-opacity-5 border border-white border-opacity-10 rounded-xl p-8 hover-card animate-fade-in"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <h2 className="text-2xl font-bold mb-4 text-cyan-400">
                {section.title}
              </h2>
              {section.content}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
